import { downloadBlob } from "../../UI/Utils/downloadBlob.ts";
import { formatDateRome } from "../../UI/Utils/formatDateRome.ts";
import { SalesPeriod } from "./salesPeriod.ts";

export type CsvColumn<Row> = {
  header: string;
  valueOf: (row: Row) => string | number | null | undefined;
};

const SEPARATOR = ";";
const LINE_BREAK = "\r\n";
const BYTE_ORDER_MARK = "﻿";

function toCsvCell(value: string | number | null | undefined): string {
  const text = value === null || value === undefined ? "" : String(value);
  return /[";\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

export function toCsv<Row>(rows: Row[], columns: CsvColumn<Row>[]): string {
  return [
    columns.map((column) => toCsvCell(column.header)),
    ...rows.map((row) =>
      columns.map((column) => toCsvCell(column.valueOf(row))),
    ),
  ]
    .map((cells) => cells.join(SEPARATOR))
    .join(LINE_BREAK);
}

export function centsForCsv(cents: number): string {
  return (cents / 100).toFixed(2).replace(".", ",");
}

export function ratioForCsv(ratio: number): string {
  return (ratio * 100).toFixed(1).replace(".", ",");
}

export function dateTimeForCsv(utcDateTime: string): string {
  return formatDateRome(utcDateTime);
}

export function downloadSalesCsv({
  section,
  period,
  csv,
}: {
  section: string;
  period: SalesPeriod;
  csv: string;
}): void {
  downloadBlob(
    new Blob([BYTE_ORDER_MARK + csv], { type: "text/csv;charset=utf-8" }),
    `statistiche-vendite-${section}-${period.from.format("YYYY-MM-DD")}_${period.to.format("YYYY-MM-DD")}.csv`,
  );
}
